import styled from 'styled-components';

export const UpdateKeyResultContainer = styled.div`
  width: 100%;
  max-width: 750px;
  margin: 70px auto;
`;

export const Status = styled.div`
  font-size: 0.9375rem;
  line-height: 1.67;
  letter-spacing: 0.25px;
  text-align: center;
  color: ${({ theme }) => theme.white.a6};
  padding-top: 15px;
`;

export const ListWrapper = styled.div`
  padding-top: 15px;
  color: ${({ theme }) => theme.white.a6};
  width: 750px;
  border-top: 1px solid ${({ theme }) => theme.white.a6};
`;

export const ListContainer = styled.div`
  margin-top: 45px;
  display: flex;
  justify-content: center;
`;
